// extracted by mini-css-extract-plugin
export default {"img":"HomePartners_img__BxiKN","boxs":"HomePartners_boxs__Ap+lG","controlleft":"HomePartners_controlleft__3n0Ds","controlright":"HomePartners_controlright__oP15K"};